import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { ArrowRight } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-[#0B1F33]">
      {/* Background Image - Abstract Data */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1639322537228-f710d846310a?q=80&w=2832&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1F33] via-[#0B1F33]/85 to-[#0B1F33]/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F33] via-transparent to-[#0B1F33]/40"></div>
      </div>

      {/* Decorative Glow Orbs */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#1F7A8C]/20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-1/3 left-1/4 w-64 h-64 bg-[#3B82F6]/10 rounded-full blur-[100px] pointer-events-none"></div>

      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `linear-gradient(rgba(91, 181, 197, 0.3) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(91, 181, 197, 0.3) 1px, transparent 1px)`,
        backgroundSize: '80px 80px'
      }}></div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-8 relative z-10 pt-24 lg:pt-28 pb-16 lg:pb-20">
        <div className="max-w-3xl">
          {/* Label */}
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest mb-4">
            SAP Master Data Governance Specialists
          </p>

          {/* Main Headline - Clean with subtle accent */}
          <h1 className="font-semibold text-2xl sm:text-3xl lg:text-4xl leading-tight mb-5">
            <span className="text-[#5BB5C5]">SAP Master Data Governance</span>
            <span className="text-white">-First</span>
            <br />
            <span className="text-[#B8C8D8]">Consulting</span>
          </h1>

          {/* Subheadline - subtle highlights */}
          <p className="text-[#B8C8D8] text-base lg:text-lg leading-relaxed mb-4 max-w-2xl">
            <span className="text-[#E8B86D]">{companyInfo.name}</span> is a 
            <span className="text-[#5BB5C5]"> SAP Master Data Governance</span>-first consulting company. 
            <span className="text-[#5BB5C5]"> SAP MDG</span> is our primary specialization, covering 
            implementation, governance audit, compliance alignment, and S/4HANA data transformation.
          </p>

          {/* Secondary Services Note */}
          <p className="text-[#8899AA] text-sm lg:text-base leading-relaxed mb-8 max-w-2xl">
            We also deliver supporting SAP services, software engineering, automation, analytics, 
            AI, and DevOps capabilities where they strengthen MDG-led programs.
          </p>

          {/* Key Capabilities */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 py-5 border-t border-b border-[#5BB5C5]/20">
            {['MDG Implementation', 'Governance Audit', 'S/4HANA Alignment', 'Audit Readiness'].map((item, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-[#5BB5C5] rounded-full"></div>
                <p className="text-[#B8C8D8] font-medium text-sm">{item}</p>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <ScrollLink
              to="contact"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              className="btn-primary cursor-pointer"
            >
              Contact Us
              <ArrowRight className="w-4 h-4 ml-2" />
            </ScrollLink>
            <ScrollLink
              to="services"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              className="btn-secondary cursor-pointer"
            >
              View Services
            </ScrollLink>
          </div>
        </div>

        {/* Framework Badge */}
        <div className="mt-10 pt-6 border-t border-[#5BB5C5]/15">
          <p className="text-[#8899AA] text-sm">
            All <span className="text-[#6AACBC]">SAP Master Data Governance</span> delivery is powered by the <span className="text-[#5BB5C5] font-medium">{companyInfo.frameworkTrademark}</span> governance framework.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
